import _ from 'lodash';
import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ForwarderService, Staff, Staff2, UserModel, PagerService, AlertService, CnsltnFwdr, Corporation2, QuotationService, ConsultRequestService, TableHeader, CommonService, CnsltnFwdrModel, TransType, Forwarder, CnsltnType, Speciality, Region, QuotEntryCorps } from '../../../../services/index';
import { Util, CommonUtil } from 'app/utils';
import { Subscription } from 'rxjs';
import { Utils } from 'ag-grid';
import { SelectComponent } from 'ng2-select';
import { FwdrFareManagement } from 'app/containers/fwdr-fare/fwdr-fare-management';
declare var $:any;

@Component({
  selector: 'cnsltn-fwdrs',
  templateUrl: 'cnsltn-fwdrs.html'
})


export class CnsltnFwdrsComponent implements OnInit, OnDestroy{

  headerList:Array<TableHeader> = null;
  searchingEntryCorps = false;
  loading = false;

  _reqNo:string;
  @Input() set reqNo(reqNo:string){
    if(reqNo){
      this._reqNo = reqNo;
      this.getCnsltnFwdr(reqNo);
      this.getEntryCorpsInfo();
    }
  }

  get reqNo():string{
      return this._reqNo;
  }
  
  _stusCd:number;
  @Input() set stusCd(stusCd:number){
    if(stusCd != null && stusCd != undefined){
      this._stusCd = stusCd;
      this.loading = true;
      this.getTargetFwdrs();
      this.getEntryCorpsInfo();
    }
  }

  get stusCd():number{
      return this._stusCd;
  }
  

  @Input() orgCntryCd;
  @Input() desCntryCd;
  @Input() cnsltnType:TransType;

  @Output() hideEe: EventEmitter<any> = new EventEmitter();
  @Output() refreshEe: EventEmitter<any> = new EventEmitter();

  fwdrCorpList:Array<Forwarder> = new Array();
  filteredfwdrCorpList: Array<Forwarder> = new Array();

  searchText:string = ''; 

  pager: any = {};
  pagedItems: Array<Forwarder> = new Array();

  cnsltnFwdrList: Array<CnsltnFwdrModel> = new Array();

  getStusNm:Function = QuotationService.getStusNm;
  getImOrPossible:Function = QuotationService.getImOrPossible;
  phoneFormatter:Function = Util.phoneFormatter;

  headerSortedSub:Subscription;
  headerClearSub:Subscription;

  clickedHader:TableHeader;

  targetFwdrsSub:Subscription;
  cnsltnFwdrsSub:Subscription;
  requestCnsltnFwdrsSub:Subscription;
  saveCnsltnFwdrsSub:Subscription;
  
  emailYnItems:Array<any> = new Array<any>();
  cnsltnStusItems:Array<any> = new Array<any>();

  @ViewChild("statusSelect")
  statusSelect: SelectComponent;
  
  quotEntryCorpsList:Array<QuotEntryCorps> = new Array<QuotEntryCorps>();

  constructor( 
    private forwarderService : ForwarderService,
    private pagerService: PagerService,
    private alertService: AlertService,
    private quotationService:QuotationService,
    private consultService:ConsultRequestService,
    private commonService:CommonService
  ) {
    this.headerSortedSub = commonService.headerSortedEmit.subscribe(sortedData =>{
      this.cnsltnFwdrList = sortedData;
      // this.setPage(1);
    });
    this.headerClearSub = commonService.clearHeaderEmit.subscribe(headers =>{
      this.headerList = headers;
    });
  }

  ngOnInit() {
    this.makeYnItemList(); 
    this.newMethod();
    this.makeCnsltnStusItems();
    // this.getTargetFwdrs();
    // this.makeOfficeListForDrp(this.officeList);
  }

  makeYnItemList(){
    this.emailYnItems.push({text:'사용', id:"0"}); 
    this.emailYnItems.push({text:'미사용', id:"1"}); 
  }

  makeCnsltnStusItems(){
    this.cnsltnStusItems.push({text:'견적 요청', id:"0"});
    this.cnsltnStusItems.push({text:'견적 참여', id:"1"});
    this.cnsltnStusItems.push({text:'부킹 요청', id:"2"});
    this.cnsltnStusItems.push({text:'진행중', id:"3"});
    this.cnsltnStusItems.push({text:'도착 완료', id:"4"});
    this.cnsltnStusItems.push({text:'운송 완료', id:"5"});
  }
  
  private newMethod() {
    this.makeHeader();
  }

	close() {
    this.hideEe.emit();
    this.subClose();
  }

  ngOnDestroy(){
    this.subClose();
  }

  subClose(){
    
    if(this.headerSortedSub){
      this.headerSortedSub.unsubscribe();
    }

    if(this.headerClearSub){
      this.headerClearSub.unsubscribe();
    }

    if(this.targetFwdrsSub){
      this.targetFwdrsSub.unsubscribe();
    }

    if(this.cnsltnFwdrsSub){
      this.cnsltnFwdrsSub.unsubscribe();
    }

    if(this.requestCnsltnFwdrsSub){
      this.requestCnsltnFwdrsSub.unsubscribe();
    }

    if(this.saveCnsltnFwdrsSub){
      this.saveCnsltnFwdrsSub.unsubscribe();
    }
  }

  clickOutside() {
    this.close();
  }

  getEntryCorpsInfo(){
    if(this.reqNo && this.stusCd != null && this.stusCd != undefined && this.stusCd >= 1 && !this.searchingEntryCorps) {
      this.searchingEntryCorps = true;
      this.consultService.getEntryCorpsInfo(this.reqNo).subscribe(
        resp => {
          if(resp.result && resp.data){
            this.quotEntryCorpsList = resp.data.corpInfoList;
            this.searchingEntryCorps = false;
          }
      });
    }
  }

  getCnsltnFwdr(reqNo:string){
    this.cnsltnFwdrsSub = this.consultService.getCnsltnFwdrList(reqNo).subscribe(
      resp => {
        if(resp.result && resp.data) {
          this.cnsltnFwdrList = _.orderBy(resp.data, ['stusNm', 'corpNm'], ['asc', 'asc']);
        }
      }
    );
  }

  getTargetFwdrs(){
    this.targetFwdrsSub = this.forwarderService.getFwdrsWithCnsltnRegionAndSpeciality().subscribe(res => {
      if(res.result && res.data){
        this.fwdrCorpList = _.filter(res.data, (fwdrCorp:Forwarder) => {
          if(fwdrCorp.isCnsltn == 1) return true;
          else return false;        
        });
        this.filteredfwdrCorpList = this.fwdrCorpList;
        this.setPage(1);
      }else{
        // $.sweetModal({
        //   content: res.errorMsg,
        //   icon: $.sweetModal.ICON_WARNING
        // });
      }
      this.loading = false;
    });
    // this.forwarderService.getCorpList().subscribe((res:any) =>{
    //   if(res.result){
    //     this.fwdrCorpList = _.filter(res.data, (fwdrCorp:Corporation2) => {
    //       if(fwdrCorp.typeCd == 1 || fwdrCorp.corpId == 150) return true;
    //       else return false;        
    //     });
    //     this.filteredfwdrCorpList = this.fwdrCorpList;
    //     this.setPage(1);
    //   }else{
    //     $.sweetModal({
    //       content: res.errorMsg,
    //       icon: $.sweetModal.ICON_WARNING
    //     });
    //   }
    // });
  }
  // makeNotRegfwdrCorpListForDrp(data) {
  //   this.notRegfwdrCorpListForDrp = _.map(data, (notRegEmp, index) => {
  //     notRegEmp.value = notRegEmp.email;
  //     notRegEmp.label = notRegEmp.email;
  //     return notRegEmp;
  //   });
  // }

  // makeOfficeListForDrp(data) {
  //   this.officeListForDrp = _.map(data, (office, index) => {
  //     office.value = office.officeId;
  //     office.label = office.officeNm;
  //     return office;
  //   });
  // }

  checkAll(isChecked) {    
    if (_.isEmpty(this.pagedItems)) return;
    for(let i = 0 ; i < this.pagedItems.length ; i++) {
      this.pagedItems[i].isChecked = isChecked;
    }
  }

  // addEmployee() {

  // }

  // cancelEmployee(i:number) {
  //   let that = this;
  //   $.sweetModal.confirm('취소를 진행 하시겠습니까?', function() {
  //     if(that.fwdrCorpList[i].employeeId != null && that.fwdrCorpList[i].employeeId != undefined){
  //       that.forwarderService.delEmployeeUser(that.corpId, that.fwdrCorpList[i].employeeId).subscribe(
  //         resp=>{
  //           if(resp.result) {
  //             $.sweetModal({
  //               content: '취소 되었습니다.',
  //               icon: $.sweetModal.ICON_SUCCESS,
  //             })
  //           } else {
  //             $.sweetModal({
  //               content: resp.errorMsg,
  //               icon: $.sweetModal.ICON_WARNING
  //             })
  //           }
  //         }
  //       );
  //     }
  //     that.fwdrCorpList.splice(i, 1);
  //   }, function(){});
  // }

  updateEmployeeStusCd(i:number, stusCd:number){
    // let that = this;
    // let msg = '승인을';
    // if(stusCd == 2) msg = '취소를';
    // let emp = _.cloneDeep(that.fwdrCorpList[i]);
    // let copyStusCd = emp.stusCd;
    // emp.stusCd = stusCd;

    // $.sweetModal.confirm(msg + ' 진행 하시겠습니까?', function() {
    //   if(that.fwdrCorpList[i].employeeId != null && that.fwdrCorpList[i].employeeId != undefined){
    //     that.forwarderService.updFwdrEmployeeStusCd(that.corpId, that.fwdrCorpList[i].employeeId, emp).subscribe(
    //       resp=>{
    //         if(resp.result) {
    //           that.alertService.success('상태 변경이 완료되었습니다.');
    //           that.initSearch();
    //         }
    //       }
    //     );
    //   }
    // }, function(){
    //   emp.stusCd = copyStusCd;
    // });
  }

  emailSelected(event, i) {
    // var selectedIndex = _.findIndex(this.fwdrCorpList, {email: event.value});
    // if(selectedIndex != -1) {
    //   $.sweetModal({
    //     content: '이미등록되어 있습니다.',
    //     icon: $.sweetModal.ICON_WARNING,
    //   })

    //   this.fwdrCorpList.splice(i, 1);
    //   return;
    // }

    // var selectedEmp = _.find(this.notRegfwdrCorpList, {email: event.value});
    // var employee = this.fwdrCorpList[i];
    // employee.corpId = this.corpId;  
    // employee.userId = selectedEmp.userId;
    // employee.jobTp = selectedEmp.jobTp;
    // employee.name = selectedEmp.lastNm + selectedEmp.firstNm;
    // employee.tel = selectedEmp.tel;
    // employee.mobile = selectedEmp.mobile;
    // employee.fax = selectedEmp.fax;
    // employee.email = selectedEmp.email
  }

  officeSelected(event, i) {
    var employee = this.fwdrCorpList[i];
    // employee.officeId = event.value;
    // employee.officeNm = event.label;
  }

  onChangeInput(index, fieldNm, value) {
    this.pagedItems[index][fieldNm] = value;
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.filteredfwdrCorpList.length, page, 10);

    // if (page < 1) {
    //   return;
    // } 

    this.pagedItems = this.filteredfwdrCorpList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  
  requestCnsltnFwdrs() {
    Util.confirm("해당 포워더들에게 견적을 요청 하시겠습니까?", () => {
      this.consultService.doRequestCnsltnFwdrs(this.reqNo, this.cnsltnFwdrList).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('견적 요청이 완료 되었습니다.');
            this.getTargetFwdrs();
            this.getCnsltnFwdr(this.reqNo);
            this.refreshEe.emit();
            this.hideEe.emit();
          } else {
            $.sweetModal({
              content: resp.errorMsg,
              icon: $.sweetModal.ICON_WARNING,
              closeOnClickOutside: false
            });
          }
        }
      );
    }, () => {});
  }

  saveCnsltnFwdrs() {

    if(this.stusCd >= 2){  
      let equivalentStusCdCnt = this.cnsltnFwdrList.filter( cnsltnFwdr => {
        return cnsltnFwdr.stusCd === this.stusCd;
      }).length;

      if(equivalentStusCdCnt < 1){
        Util.alertWarn('견적의 상태는 : ' + this.getStusNm(this.stusCd) + ' 입니다. \n견적 포워더 목록에 해당 상태값이 존재하지 않습니다.');
        return false;
      }

      let equivalentStusCdCnt2 = this.cnsltnFwdrList.filter( cnsltnFwdr => {
        return cnsltnFwdr.stusCd >= 2;
      }).length;

      if(equivalentStusCdCnt2 > 1){
        Util.alertWarn('견적의 상태는 : ' + this.getStusNm(this.stusCd) + ' 입니다. \n' + this.getStusNm(this.stusCd) + ' 현재 상태 이상인 상태가 2개이상 존재합니다. 상태를 확인해주세요');
        return false;
      }
    }

    Util.confirm("저장 하시겠습니까?", () => {
      this.consultService.insertNewCnsltnFwdrsOrUpdateDelYnCnsltnFwdrs(this.reqNo, this.cnsltnFwdrList).subscribe(
        resp => {
          if(resp.result) {
            this.alertService.success('저장 되었습니다.');
            this.getTargetFwdrs();
            this.getCnsltnFwdr(this.reqNo);
            this.hideEe.emit();
          } else {
            $.sweetModal({
              content: resp.errorMsg,
              icon: $.sweetModal.ICON_WARNING,
              closeOnClickOutside: false
            });
          }
        }
      );
    }, () => {});

  }

  addToCnsltnFwdrs() {
    for(let i = 0 ; i < this.pagedItems.length ; i++) {
      var fwdr = this.pagedItems[i];
      if(fwdr.isChecked) {
        var corpId = _.find(this.cnsltnFwdrList, {corpId : fwdr.corpId});
        if(corpId != null) continue;

        var cnsltnFwdr = new CnsltnFwdrModel();
       
        cnsltnFwdr.reqNo = this.reqNo;
        cnsltnFwdr.corpId = fwdr.corpId;
        cnsltnFwdr.stusNm = 'BEFORE_REQUEST_QUOT';
        cnsltnFwdr.cnsltnImOrPossible = 'POSSIBLE';
        cnsltnFwdr.stusCd = 0;
        cnsltnFwdr.emailReceiveYn = true;
        let regUser = fwdr.regUser;
        if(regUser){
          cnsltnFwdr.managerNm = regUser.lastNm + regUser.firstNm;
          cnsltnFwdr.email = regUser.email;
          cnsltnFwdr.mobile = regUser.mobile;
        }
        
        cnsltnFwdr.corpNm = fwdr.corpNm;
                
        this.cnsltnFwdrList.push(cnsltnFwdr);
      }
    }
  }

  search(event) {
    var filterValue = event.target.value;

    this.filteredfwdrCorpList = _.filter(this.fwdrCorpList, item => {
			if (!filterValue) return true;

			let valuesStr = this.getString(item, ['corpNm', 'regUser', 'corpRegNo']);
      const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
			return valuesStr.indexOf(filter) >= 0;
    });
    
    this.setPage(1);
  }

  getString(obj:Object, propertyNames?:String[]):string {

		let valuesStr:string = '';
    let targetObj = null;

    if(propertyNames){
      targetObj = propertyNames;
    }else{
      targetObj = obj;
    }

    for (let propertyName in targetObj) {

      if(!isNaN(Number(propertyName))){
        propertyName = propertyNames[propertyName];
      }

      let itemValue = obj[propertyName];
      if (itemValue instanceof String) itemValue = itemValue.toLocaleLowerCase();
      else if (itemValue instanceof Object) itemValue = this.getString(obj[propertyName]).toLocaleLowerCase();
      else itemValue = String(itemValue).toLocaleLowerCase();

      if(propertyName == 'firstNm') valuesStr += itemValue;
      else valuesStr += '|' + itemValue;
    }

    valuesStr = valuesStr.replace(/\s/gi, "");

		return valuesStr;
	}

  deleteFwdr(i:number){
    if(this.cnsltnFwdrList[i].cnsltnFwdrId){
      this.cnsltnFwdrList[i].delYn = true;
    }else{
      this.cnsltnFwdrList.splice(i, 1);
    }
  }

  makeHeader(){
    this.headerList = new Array<TableHeader>();
    this.headerList.push(new TableHeader(0, 'corpId', 'No.', true));
    this.headerList.push(new TableHeader(1, 'stusNm', '포워더 견적 상태', true));
    this.headerList.push(new TableHeader(2, 'corpNm', '회사명', true));
    this.headerList.push(new TableHeader(3, 'managerNm', '담당자', true));
    this.headerList.push(new TableHeader(4, 'email', '이메일', true));
    this.headerList.push(new TableHeader(5, 'mobile', '연락처', true));
    this.headerList.push(new TableHeader(6, 'cnsltnImOrPossible', '견적가능여부', true));       
    this.headerList.push(new TableHeader(7, '', '이메일 발송 여부', false));
    this.headerList.push(new TableHeader(8, '', '삭제', false));
           
  }

  headerClick(header:TableHeader){
    this.clickedHader = header;
    this.commonService.headerClick(header, this.cnsltnFwdrList);
  }

  isPossibleAddOrDel(){
    return this.stusCd != null && this.stusCd > -2 && this.stusCd < 2;
  }
  

  isRequest(){
    return this.stusCd != null && this.stusCd == -2;
  }

  allCnsltnFwdr(){
    this.filteredfwdrCorpList = this.fwdrCorpList;
    this.setPage(1);
  }

  conditionCnsltnFwdr(){
    this.filteredfwdrCorpList = this.fwdrCorpList.filter(fwdr => {
      let findSpeciality = fwdr.specialityList.find(item => this.isExistCnsltnType(item));
      let findRegion = fwdr.regionList.find(item => this.isExistRegion(item));

      if(fwdr.isCnsltn == 1 && findSpeciality && findRegion){
        return true;
      }else{
        return false;
      }
    });

    this.setPage(1);
  }

  isExistCnsltnType(item:Speciality):boolean{

    let type = CnsltnType[this.cnsltnType];

    if(!item || !type) return false;   

    return item.itemNm.toLowerCase().indexOf(type.toLowerCase()) > -1;
  }

  isExistRegion(item:Region):boolean{
    if(!this.orgCntryCd || !this.desCntryCd || !item || !item.code){
      return false;
    }

    return item.code.toLowerCase().indexOf(this.orgCntryCd.toLowerCase()) > -1 || item.code.toLowerCase().indexOf(this.desCntryCd.toLowerCase()) > -1;
  }

  selectedEmailYn(value:any, i:number):void {
    this.cnsltnFwdrList[i].emailReceiveYn = !this.cnsltnFwdrList[i].emailReceiveYn;
  }

  selectedCnsltnStatus(value:any, i:number, target:SelectComponent){
    let stusCd = Number(value.id);
    if(!this.isValidStusCd(stusCd, i)){
      let curStusCd = this.cnsltnFwdrList[i].stusCd;
      target.active = curStusCd != null && curStusCd != undefined ? [{id: curStusCd, text:this.getStusNm(curStusCd)}] : null;
      return;
    }
    
    this.cnsltnFwdrList[i].stusCd = stusCd;
  }

  isValidStusCd(selectedStusCd:number, selectedIndex?:number):boolean{
    if(this.stusCd < 1 && selectedStusCd >= 1) {
      Util.alertWarn('견적 참여 이전 상태에서는 견적 참여 이상의 상태로 변경이 불가능 합니다.');
      return false;
    }

    if(this.stusCd < 2 && selectedStusCd >= 2) {
      Util.alertWarn('부킹 요청 이전 상태에서는 부킹 요청 이상의 상태로 변경이 불가능 합니다.');
      return false;
    }

    if(this.stusCd < 3 && selectedStusCd >= 3) {
      Util.alertWarn('진행중 이전 상태에서는 진행중 이상의 상태로 변경이 불가능 합니다.');
      return false;
    }

    if(this.stusCd < 4 && selectedStusCd >= 4) {
      Util.alertWarn('도착 완료 이전 상태에서는 도착 완료 이상의 상태로 변경이 불가능 합니다.');
      return false;
    }

    if(this.stusCd < 5 && selectedStusCd >= 5) {
      Util.alertWarn('운송 완료 이전 상태에서는 운송 완료 이상의 상태로 변경이 불가능 합니다.');
      return false;
    }

    if(this.stusCd >= 2){

      let equivalentStusCdCnt = this.cnsltnFwdrList.filter( (cnsltnFwdr, index) => {
        if(index != selectedIndex && cnsltnFwdr.stusCd >= 2){
          return true;
        }else{
          return false;
        }
      }).length;

      if(equivalentStusCdCnt > 1){
        Util.alertWarn('동일한 상태가 2개 이상입니다. 확인 후 다시 상태값을 선택해주세요.');
        return false;
      }

    }  
    
    let cnsltnFwdr = this.cnsltnFwdrList[selectedIndex];
    let corpId = cnsltnFwdr.corpId;

    if(selectedStusCd == 1){
      if(!this.quotEntryCorpsList || !this.isExistEntryCorpId(corpId)){
        Util.alertWarn('참여한 견적이 없습니다. 등록된 견적이 있는지 확인해주세요.');
        return false;
      }
    }

    if(selectedStusCd >= 2){
      if(!this.quotEntryCorpsList || !this.isExistMapthingCorpId(corpId)){
        Util.alertWarn('매칭된 견적이 아닙니다. 매칭된 견적이 맞는지 확인해주세요.');
        return false;
      }
    }

    return true;
  }

  isExistEntryCorpId(fwdrCorpId:number){
    return this.quotEntryCorpsList.filter(fc => {
      return fc.corpId == fwdrCorpId;
    }).length > 0;
  }

  isExistMapthingCorpId(fwdrCorpId:number){
    return this.quotEntryCorpsList.filter(fc => {
      return fc.corpId == fwdrCorpId && fc.status == 'CHOICE';
    }).length > 0;
  }


  notDeleteFwdr(i:number){
    this.cnsltnFwdrList[i].delYn = false;
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/cnsltn-fwdrs.ts